import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  Room,
  RoomResponse,
  RoomSingleResponse,
  RoomType
} from 'Interfaces/ReferenceInterfaces/RoomInterface';

export interface RoomTypeResponse {
  status: boolean;
  data: RoomType[];
  pagination: {
    current_page: number;
    total_pages: number;
    total_items: number;
    has_next: boolean;
    has_previous: boolean;
  };
  message: string;
}

export interface RoomTypeSingleResponse {
  status: boolean;
  data: RoomType;
  message: string;
}

export const roomScreenServices = {
  getAllRooms: (page = 1, pageSize = 10000): Promise<RoomResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<RoomResponse>(`pps/rooms?page=${page}&page_size=111`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getRoomById: (id: number): Promise<RoomSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<RoomSingleResponse>(`pps/rooms/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createRoom: (roomData: Partial<Room>): Promise<RoomSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<RoomSingleResponse>('pps/rooms/', roomData);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateRoom: (id: number, roomData: Partial<Room>): Promise<RoomSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<RoomSingleResponse>(`pps/rooms/${id}/`, roomData);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteRoom: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/rooms/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  // Room Types endpoints
  getAllRoomTypes: (page = 1, pageSize = 100): Promise<RoomTypeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<RoomTypeResponse>(
          `pps/room-types?page=${page}&page_size=${pageSize}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getRoomTypeById: (id: number): Promise<RoomTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<RoomTypeSingleResponse>(`pps/room-types/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createRoomType: (roomTypeData: Partial<RoomType>): Promise<RoomTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<RoomTypeSingleResponse>('pps/room-types/', roomTypeData);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateRoomType: (
    id: number,
    roomTypeData: Partial<RoomType>
  ): Promise<RoomTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<RoomTypeSingleResponse>(
          `pps/room-types/${id}/`,
          roomTypeData
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteRoomType: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/room-types/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
